import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import {
  registerItemsKeys,
  RequestTypes,
} from '@core/react-query/features/registers/registers/register/items'
import { RegisterItem } from '@core/entities/register/RegisterItem'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  IRegisterItemsResponse,
  RegisterItemsResponse,
} from '@core/entities/register/RegisterItemsResponse'
import { usePageableQuery } from '@core/react-query/hooks'
import { RegisterItemColumn } from '@core/entities/register/RegisterItemColumn'

const dataTransformer = (response: IRegisterItemsResponse) => {
  return {
    ...response,
    columns: response.columns.map((column) => RegisterItemColumn.new(column)),
    content: response.content.map((registerItem) =>
      RegisterItem.new(registerItem),
    ),
    // Dirty cast here, should fix this to property map the page response
  } as RegisterItemsResponse
}

export const useGetRegisterItems = (
  payload: RequestTypes['getRegisterItems'],
  options?: UseInfiniteQueryOptions<
    IRegisterItemsResponse,
    RequestErrorType,
    RegisterItemsResponse
  >,
) => {
  const registerItemsQuery = registerItemsKeys.itemsByRegisterId(payload)

  const infiniteQueryOptions = usePageableQuery({
    queryEnabled: options?.enabled,
    queryKey: registerItemsQuery.queryKey,
    dataTransformer,
  })

  return useInfiniteQuery<
    IRegisterItemsResponse,
    RequestErrorType,
    RegisterItemsResponse
  >({
    ...registerItemsQuery,
    ...infiniteQueryOptions,
    keepPreviousData: true,
    ...options,
  })
}
